<template>
  <div class="page-wrap">
    <Card :bordered="false" :padding="100" dis-hover class="notice-card">
      <img src="@/assets/border-img-t-l.png" alt="" class="border-img border-top-left">
      <img src="@/assets/border-img-t-r.png" alt="" class="border-img border-top-right">
      <img src="@/assets/border-img-b-l.png" alt="" class="border-img border-bottom-left">
      <img src="@/assets/border-img-b-r.png" alt="" class="border-img border-bottom-right">
      <x-title title="温馨提示"></x-title>
      <div v-html="data"></div>
    </Card>
    <!-- <Page :total="data1.length" :styles="{textAlign: 'right'}"/> -->
  </div>
</template>

<script>
import api from '@/api'
import { httpAction } from '@/api/manage'
import xTitle from '@/components/xTitle/index'
export default {
  components: {
    'x-title': xTitle
  },
  data () {
    return {
      columns1: [
        {
          title: 'publishTime',
          key: 'publishTime',
          width: 150,
           render: (h,params)=>{
              return h('div',
                  (params.row.publishTime && params.row.publishTime.length > 10)? params.row.publishTime.substring(0, 10): params.row.publishTime
              )
          }
        },
        {
          title: 'typeName',
          key: 'typeName',
          width: 200
        },
        {
          title: 'title',
          key: 'title'
        },
        {
          title: 'Action',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ],
      data: [
        // {
        //   title: '票务公告',
        //   notice: '颐和园关于恢复开放部分景区及封闭院落的公告',
        //   date: '2020-04-28'
        // },
        // {
        //   title: '票务公告',
        //   notice: '颐和园恢复开放景区的公告',
        //   date: '2020-06-19'
        // },
        // {
        //   title: '票务公告',
        //   notice: '温馨提示',
        //   date: '2020-06-17'
        // }
      ]
    }
  },
  mounted () {
    this.getNoticeList()
  },
  methods: {
    getNoticeList() {
      httpAction(api.noticeList, 'post',{type:1}).then(res => {
        this.data = res.data.noticeListVO[0].content
      })
    },
    show (row) {
      this.$router.push({ path: '/park_notice/notice', query: { id: row.id } })
    },
    rowClass (row, index) {
      return 'table-select'
    }
  }
}
</script>

<style scoped>
  .page-wrap{
    height: 100%;
    width: 100%;
  }
  .notice-card{
    margin: 20px 0;
  }
  .table-select{
    cursor: pointer;
  }
</style>
